'use client';

import { ButtonBase, Tooltip } from '@mui/material';
import classnames from 'classnames';
import { signIn, useSession } from 'next-auth/react';
import { BsGoogle } from 'react-icons/bs';

import { DrawerComponent } from '../Drawer';

import styles from './styles.module.scss';

import { useModalContext } from '@/context/ModalContext';

export function LoginComponent() {
  const { modal, setModal } = useModalContext();
  const { data } = useSession();
  const user = data?.user;

  return (
    <>
      <div className={styles.loginContainer}>
        <Tooltip title="Fazer login">
          <ButtonBase
            onClick={() => {
              return setModal(!modal);
            }}
            sx={{
              gap: 1,
              color: 'white',
              borderRadius: '8px',
              padding: '8px 8px',

              '& .MuiAvatar-root': {
                width: 32,
                height: 32
              }
            }}
          >
            <p className={styles.enter}>Entrar</p>
          </ButtonBase>
        </Tooltip>
      </div>
      <DrawerComponent
        drawer={modal}
        setDrawer={() => {
          setModal(false);
        }}
        height="calc(100% - var(--height-header))"
        className={styles.drawer}
      >
        <p className={styles.title}>Vamos fazer seu login?</p>
        <p className={styles.description}>Para ter acesso as configurações da sua conta, você precisa fazer o login.</p>

        {!user && (
          <div className={styles.socialLogin}>
            <p className={styles.socialLoginTitle}>Faça seu login com:</p>
            <div className={styles.socialLoginButtons}>
              <ButtonBase
                className={classnames(styles.socialLoginButton, {
                  [styles.googleTheme]: true
                })}
                type="button"
                onClick={() => {
                  setModal(false);
                  signIn('google');
                }}
                name="google"
              >
                <BsGoogle />
              </ButtonBase>
              {/* <ButtonBase
                className={classnames(styles.socialLoginButton, {
                  [styles.facebookTheme]: true
                })}
                type="button"
                onClick={() => signIn('facebook')}
              >
                <BsFacebook />
              </ButtonBase> */}
            </div>
          </div>
        )}
      </DrawerComponent>
    </>
  );
}
